import { ExcelFileNameTypes } from '@entities/generation-state';

type MapperType = {
  [key in ExcelFileNameTypes]: string;
};

export const getEndpoint = (type: ExcelFileNameTypes) => {
  const endpointMapper: MapperType = {
    customerFileName: 'customer-data',
    monthFileName: 'month-data',
    staffFileName: 'staff-data',
  };

  return endpointMapper[type];
};
